export function header() {
    let win = window;
    let $body = $("body");
    let activeClass = "active";
    let openClass = "open";
    let showMenuClass = "show-menu";
    let openMenuName = "open-menu";
    // let expandedAttr = "aria-expanded";
    let navBtnName = "menu-item-button";
    let durationDefault = 400;
    let durationDesktop = 150;
    let getIsDesktop = function () {
        return win.innerWidth >= 1200;
    };
    let openTarget = null;
    const $header = $(".header");
    const $footer = $(".footer");
    let scrollYPosition = $(win).scrollTop();

    function addTarget($target) {
        let $item = $target.closest("li");
        openTarget = {
            $btn: $target,
            $item: $item,
            $dropdown: $item.find(".dropdown").eq(0)
        };
    }

    function removeTarget() {
        openTarget = null;
    }

    function toggleDropdown(isOpen) {// show by default
        let duration = durationDefault;

        openTarget.$item[`${isOpen ? "remove" : "add"}Class`](openClass);
        if (!isOpen) {
            openTarget.$dropdown.css("visibility", "visible");

            if(getIsDesktop()) {
                openTarget.$dropdown.css("top", $(".header").innerHeight());
                $(".header").append("<span class=\"dropdown-bg\"></span>");
            } else {
                if (!openTarget.$item.hasClass("nav-dropdown-col")) {
                    openTarget.$item.siblings().addClass("no-active");
                }
            }
        }

        openTarget.$dropdown[`slide${isOpen ? "Up" : "Down"}`](duration, function () {
            if (isOpen) {
                $(this).css("visibility", "hidden");

                if(getIsDesktop()) {
                    $(this).css("top", "auto");
                    $(".dropdown-bg").remove();
                } else {
                    if ($(".header").find(":not(.nav-dropdown-col).open").length === 0) {
                        $(".header").find(".no-active").removeClass("no-active");
                    }
                }
            }
        });

        // openTarget.$btn.attr(expandedAttr, !isOpen);
    }

    function headerToggleDownClass(currentScrollPosition) {
        const footerTop = $footer.offset().top;

        if (currentScrollPosition > 0) {
            $header[`${currentScrollPosition > scrollYPosition ? "add" : "remove"}Class`]("down");
        } else {
            $header.removeClass("down");
        }

        if(footerTop <= currentScrollPosition + $(win).outerHeight()) {
            $header.addClass("hide");
        } else {
            $header.removeClass("hide");
        }

        const openDrop = $(".header").find(".open .menu-item-button");
        
        if  (openDrop.length) {
            $(openDrop).trigger("click");
        }

        scrollYPosition = currentScrollPosition;
    }

    $body.on("click", function (e) {
        let target = e.target;
        let $target = $(target);
        let isOpenMobileMenuBtn = $target.hasClass(openMenuName);
        let isNavBtn = ($target.hasClass(navBtnName) || $target.hasClass(navBtnName + "-arrow")) && $target.closest("li").find(".dropdown").length > 0;
        let isHeaderLinkBtn = $target.hasClass("header-link");

        if (isOpenMobileMenuBtn || isNavBtn || isHeaderLinkBtn) {
            e.preventDefault();
        }

        if (isOpenMobileMenuBtn) {  //toggle mobile menu
            // let attrValue = JSON.parse($target.attr(expandedAttr));

            // $target.attr(expandedAttr, !attrValue);
            $body.toggleClass(showMenuClass);

        } else if (isNavBtn || isHeaderLinkBtn) {  //toggle nav (main) menu dropdowns

            if (openTarget === null) {
                addTarget($target);
                toggleDropdown(); //show
            } else {
                if ($target.closest("li").hasClass("open")) {
                    addTarget($target);
                    toggleDropdown(true); //hide
                    removeTarget();
                } else {
                    if (getIsDesktop()) {
                        toggleDropdown(true); //hide old
                    }
                    addTarget($target);
                    toggleDropdown(); //show new
                }
            }
        } else if (openTarget !== null) {
            let openTargetIsNavBtn = openTarget.$btn.hasClass(navBtnName);
            let isHideDropdown = !(openTargetIsNavBtn && !getIsDesktop());

            if (isHideDropdown) {
                if (!($target.closest(openTarget.$item)).length) {
                    toggleDropdown(true); //hide
                    removeTarget();
                }
            }
        }
    });

    $(win).on("load resize scroll", function (e) {
        let scrollTop = $(win).scrollTop();
        let isTop = !getIsDesktop() && scrollTop === 0;
        
        if ($(".hero-section").length !== 0 && !$(".hero-section").hasClass("without-bg")) {
            $body[`${isTop ? "add" : "remove"}Class`]("on-top");
        }

        if (scrollTop !== 0) {
            $(".header").removeClass("has-animation");
        }

        if (getIsDesktop()) {
            headerToggleDownClass(scrollTop);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js